import { getCookie } from './../shared/cookieHelper';

window.SLMailingAddressAutoComplete = function () {
    var addressInput = document.getElementById('amailingaddress');
    var autocompleteOptions = {
        componentRestrictions: { country: "us" },
        fields: ["address_components"],
    };

    const autocomplete = new google.maps.places.Autocomplete(addressInput, autocompleteOptions);
    autocomplete.addListener("place_changed", () => {
        var place = autocomplete.getPlace();
        if (place.address_components) {
            $('[address-component="line1"]').val(place.address_components.find(c => c.types.includes("street_number"))["short_name"] + " " + place.address_components.find(c => c.types.includes("route"))["long_name"]);
            $('[address-component="city"]').val(place.address_components.find(c => c.types.includes("locality"))["long_name"]);
            $('[address-component="state"]').val(place.address_components.find(c => c.types.includes("administrative_area_level_1"))["short_name"]);
            $('[address-component="zip"]').val(place.address_components.find(c => c.types.includes("postal_code"))["short_name"]);

            $('#shipping_address_form').removeClass('d-none');
            $('#update_address').addClass('d-none');
        }
        else {
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }
    });
}

$(function () {
    if ($('#speclock_purchase_information_page').length) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=SLMailingAddressAutoComplete';
        script.async = true;
        document.body.appendChild(script);

        var $loading = $('#ll_loading-div').hide();
        $(":input").inputmask();
        $("#phone").inputmask({ "mask": "(999) 999-9999" });
        $("#aphone").inputmask({ "mask": "(999) 999-9999" });

        $('#btnSavePurchaseInfo').click(function (e) {
            e.preventDefault();

            if ($('#purchase-form').valid()) {
                var form = new FormData();

                var line1 = $('[address-component="line1"]').val();
                var line2 = $('[address-component="line2"]').val();
                var city = $('[address-component="city"]').val();
                var state = $('[address-component="state"]').val();
                var zip = $('[address-component="zip"]').val();

                if (!line1 || !city || !state || !zip) {
                    $('#error_message').removeClass('d-none');
                    return false;
                }

                form.append("line1", line1);
                form.append("line2", line2);
                form.append("city", city);
                form.append("state", state);
                form.append("zip", zip);

                var afirstname = $('#afirstname').val();
                var alastname = $('#alastname').val();
                var aphone = $('#aphone').val();
                var aemail = $('#aemail').val();
                var companyname = $('#companyname').val();

                form.append("afirstname", afirstname);
                form.append("alastname", alastname);
                form.append("aphone", aphone);
                form.append("aemail", aemail);
                form.append("companyname", companyname);

                var loc1 = getCookie("speclock_prefix_url");

                $.ajax({
                    url: loc1 + '/purchase-lock',
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    beforeSend: function () {
                        $loading.show();
                    },
                    success: function (response) {
                        $loading.hide();
                        window.location.href = loc1 + '/payment';
                    }
                });
            }
            else {
                return false;
            }
        });

        $('#update_address').on('click', function () {
            $('#shipping_address_form').removeClass('d-none');
            $('#update_address').addClass('d-none');
        });

        $('[address-component]').on('keyup change', function () {
            var $this = $(this);

            if ($this.not('[address-component="line2"]') && !$this.val()) {
                $this.addClass('blank-error');
            }
            else {
                $this.removeClass('blank-error');

                var line1 = $('[address-component="line1"]').val();
                var line2 = $('[address-component="line2"]').val();
                var city = $('[address-component="city"]').val();
                var state = $('[address-component="state"]').val();
                var zip = $('[address-component="zip"]').val();

                var address = `${line1}${line2 ? " " + line2 : ""}, ${city}, ${state} ${zip}`;
                $('#shipping_address').val(address);
            }
        });

        $('#amailingaddress').bind("cut copy paste", function (e) {
            e.preventDefault();
        });
    }
});